"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgWifi(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 22,
    preserveAspectRatio: "xMinYMin"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.681 6.54S5.368.212 14.867.212c9.5 0 13.877 6.328 13.877 6.328M5.72 12.754s2.883-4.3 9.024-4.3c6.142 0 8.997 4.092 8.997 4.092"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 17.846,
    r: 2
  })));
}

var MemoSvgWifi = /*#__PURE__*/React.memo(SvgWifi);
var _default = MemoSvgWifi;
exports["default"] = _default;